export const MEMBERSHIP_SIGNUP_PROCESS_STATUS_STARTED = 1
export const MEMBERSHIP_SIGNUP_PROCESS_STATUS_PAYMENT_REQUESTED = 735300000
export const MEMBERSHIP_SIGNUP_PROCESS_STATUS_PAYMENT_RECEIVED = 735300001
export const MEMBERSHIP_SIGNUP_PROCESS_STATUS_SIGNUP_COMPLETED = 735300002
export const MEMBERSHIP_SIGNUP_PROCESS_STATUS_CANCELLED = 735300003
